import { find, includes, isUndefined } from 'lodash';
import { OptionType } from '@lendi-ui/dropdown';

export default function getSelectedValue(options: readonly OptionType[], selectedValue?: string | string[]) {
  // handle the case for sub options
  const hasSubOptions = Array.isArray(options) && find(options, (o) => Array.isArray(o.options));
  let convertedOptions;
  if (hasSubOptions) {
    convertedOptions = options.reduce(
      (accumulator, currentValue) =>
        Array.isArray(currentValue.options)
          ? accumulator.concat(currentValue.options)
          : accumulator.concat(currentValue),
      []
    );
  } else {
    convertedOptions = options;
  }

  if (Array.isArray(selectedValue)) {
    return convertedOptions.filter((o: OptionType) => o && includes(selectedValue, o.value));
  }
  return !isUndefined(selectedValue) && find(convertedOptions, (o) => o && o.value === selectedValue);
}
